import { createEventHook } from './createEventHook'

const SIGNAL = 'signal'

/**
 * A simpler version of createEventHook, which has no event types and no data.
 * It's used for executing callbacks on arbitrary subscribers.
 *
 * For instance, you may have multiple pieces of UI that need to refetch once an action happens.
 * in that scenario, the parts needing to refetch can use the hook returned by this to
 * be able to execute the callback, while the place where the action occurs can simply call
 * the emit function, without the components needing to drill down any props to achieve this.
 */
export const createSignalHook = () => {
  const [emitSignal, useSignal] = createEventHook<{ [SIGNAL]: undefined }>()

  return [
    () => {
      emitSignal(SIGNAL, undefined)
    },
    (fn: () => void) => useSignal(SIGNAL, fn),
  ] as const
}
